const allCap = ["MRO", "U.S.", "FAA", "NBAA", "ABACE", "EBACE", "LABACE", "FAST", "EASA", "ADS", "EVS", "AOG", "GIV", "GIV-SP", "GI", "GII", "GIII", "GV", "GVI", "GVII"];
const noCap = ["IS", "TO", "IN", "AS", "OF", "AT", "A", "AND", "ITS", "BUT", "FOR"];
const enclosures = ["''", '""', "()"];
const splitters = ["-", "—", "--"];
const replacers = {
	PLANEPARTS: "PlaneParts",
	"PLANEPARTS™": "PlaneParts™",
	JETNET: "JetNet",
	"'FORMS'": "'FORMS",
	IPAD: "iPad"
};
let wordIndex = 0;
function checkWord(wordpart) {
	if (replacers[wordpart]) {
		return replacers[wordpart];
	}
	if (allCap.includes(wordpart)) {
		// wordpart is in allcap list

		return wordpart.toUpperCase();
	}
	if (wordIndex && noCap.includes(wordpart)) {
		// wordIndex is 0 for first word in str,
		// for which we do NOT want to apply
		// noCap rule
		return wordpart.toLowerCase();
	}
	return `${wordpart.charAt(0).toUpperCase()}${wordpart.slice(1).toLowerCase()}`;
}
function checkSplits(_word, wasSplit) {
	splitters.forEach(splitter => {
		if (_word.split(splitter).length > 1) {
			wasSplit = true;
			_word = _word
				.split(splitter)
				.map(wordpart => checkWord(wordpart))
				.join(splitter);
		}
	});
	return wasSplit ? _word : checkWord(_word);
}
export const titleCase = str =>
	str
		.split(" ")
		.map((word, index) => {
			wordIndex = index;
			let wasEnclosed = false;
			enclosures.forEach(enclosure => {
				enclosure = enclosure.split("");
				const atStart = word.charAt(0) === enclosure[0];
				const atEnd = word.charAt(word.length - 1) === enclosure[1];

				if (atStart || atEnd) {
					wasEnclosed = true;
					word = `${atStart ? enclosure[0] : ""}${checkWord(word.slice(atStart ? 1 : 0, atEnd ? word.length - 1 : word.length).toUpperCase())}${atEnd ? enclosure[1] : ""}`;
				}
			});
			let wasSplit = false;
			return wasEnclosed ? word : checkSplits(word, wasSplit);
		})
		.join(" ");
